import { useState } from 'react';

export interface SelectedCellInfo {
  id: string;
  field: string;
}

export interface BaseRow {
  [key: string]: any;
}

export default function useDetail<T extends BaseRow>() {
  const [selectedRow, setSelectedRow] = useState<T | null>(null);
  const [isCopy, setIsCopy] = useState(false);
  const [mode, setMode] = useState<'add' | 'edit' | 'view'>('add');
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showFormDetail, setShowFormDetail] = useState(false);

  const handleAdd = () => {
    setMode('add');
    setShowFormDetail(true);
  };

  const handleEdit = () => {
    setMode('edit');
    setShowFormDetail(true);
  };

  const handleView = () => {
    setMode('view');
    setShowFormDetail(true);
  };

  const handleCloseForm = () => {
    setShowFormDetail(false);
  };

  const handleDelete = () => {
    setShowDeleteDialog(true);
  };
  const handleCloseDeleteDialog = () => {
    setShowDeleteDialog(false);
  };

  const handleCopy = () => {
    setIsCopy(true);
    setMode('add');
    setShowFormDetail(true);
  };

  const handleRowClick = (params: { id: string; row: T }) => {
    const rowUuid = params.id || params.row?.uuid;
    if (!rowUuid) return;

    setSelectedRow(params.row);
  };

  return {
    showDeleteDialog,
    showFormDetail,
    mode,
    selectedRow,
    isCopy,
    handleRowClick,
    handleAdd,
    handleEdit,
    handleView,
    handleDelete,
    handleCloseDeleteDialog,
    handleCloseForm,
    handleCopy
  };
}
